import script from "./RewardsCatalogBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./RewardsCatalogBanner.vue?vue&type=script&setup=true&lang=js"

import "./RewardsCatalogBanner.vue?vue&type=style&index=0&id=2475d83d&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2475d83d"]])

export default __exports__